





















































































































































































































































































import Vue from 'vue'
import { mdiTwitter } from '@mdi/js';
export default Vue.extend({
  name: 'HelloWorld',

  data: () => ({
    palabras:["Palabra 1","Palabra 2","Palabra 3","Palabra 4"],
    words:["bioinformatica","genoma","LANGEBIO", "blockchain"],
    definiciones:["Sinónimo biología computacional, informática biológica.","Es el conjunto de instrucciones genéticas que se encuentra en una célula",
    "Laboratorio donde se descubrio el genoma del maíz", "Es una de las nuevas implementaciones en la verificación de genomas"],
    victoria:["La bioinformatica tambien conocida como biología computacional  permite investigar, desarrollar y aplicar herramientas informáticas y "
              + "computacionales para mejorar el manejo de datos biológicos.",
      
              "Se conoce hoy en día que los genomas del humano contiene aproximadamente 3,1 mil millones de bases de la secuencia de ADN",

            "LANGEBIO es el laboratorio donde se secuencio el genoma del maíz por primera vez en el proyecto ZEA-2006 con la colaboracion del Dr. Luis Estrella",

            "El blockchain es una de las nuevas formas en las cuales se esta comprobando que el genoma encontrado sea el correcto"
    ],
    imagenesVictoria:["bioinformatica.jpg","genoma.jpg","LANGEBIO.jpg","blockchain.jpg"],
    posicion:0,
    icons:[mdiTwitter],
    twitter:mdiTwitter,
    word:[" "," "," "," "," "," "," "," "," "," "," "," "," "," "],
    trueWord:["b","i","o","i","n","f","o","r","m","a","t","i","c","a"],
    // word:["b","i","o","i","n","f","o","r","m","a","t","i","c","a"],
    letra:"",
    letras:[],
    foto:'ahorcadoNuevo5.png',
    intentosRestantes:5,
    selectedItem: 0,
    items: [
      { text: 'Real-Time', icon: 'mdi-clock' },
      { text: 'Audience', icon: 'mdi-account' },
      { text: 'Conversions', icon: 'mdi-flag' },
    ],
    ganar:false,
    ganarDialog:false,
    perder:false,
    perderDialog:false,
    tutorial:true,
  }),
  methods: {
    checarLetra(){
      let letra = this.$data.letra; 
      let palabra = this.$data.words[this.$data.posicion];
      let correcto= false;
      for (let index = 0; index < palabra.length; index++) {
        if(palabra[index] == letra){
          this.$data.word[index] = letra;
          correcto=true;
        }
      }

      if( !this.$data.letras.includes(letra) ){
        this.$data.letras.push(letra)
      }

      
      if(!correcto){
        this.$data.intentosRestantes=this.$data.intentosRestantes-1
        this.$data.foto='ahorcadoNuevo'+this.$data.intentosRestantes+'.png'
      }
      
      if(this.$data.intentosRestantes>0){
        this.$data.foto='ahorcadoNuevo'+(this.$data.intentosRestantes-1)+'.png'
        this.$data.foto='ahorcadoNuevo'+this.$data.intentosRestantes+'.png'
      }else{
         this.$data.perder=true;
         this.$data.perderDialog=true;

      }
      if(JSON.stringify(this.$data.word) === JSON.stringify(this.$data.trueWord) ){
        this.$data.ganar=true;
        this.$data.ganarDialog=true;
        this.$data.palabras[this.$data.posicion]=this.$data.words[this.$data.posicion];
      }
      this.$data.letra="";

    },
    seleccionarPalabra( i : any){
      let palabra = this.$data.words[i];
      this.$data.posicion=i;
      let temp=[]; 
      let trueWord=[]; 
        for (let index = 0; index < palabra.length; index++) {
          temp.push(" ")
          trueWord.push(palabra[index]);
      }
      this.$data.trueWord=trueWord;
      this.$data.word=temp;

      this.$data.intentosRestantes=5;
      this.$data.foto='ahorcadoNuevo'+this.$data.intentosRestantes+'.png'
      this.$data.letras=[]
      this.$data.ganar=false;
      this.$data.perder=false;
      this.$data.ganarDialog=false;
      this.$data.perderDialog=false;

    },
     reiniciar(){
       let palabra = this.$data.words[ this.$data.posicion];
      let temp=[]; 
      let trueWord=[]; 
        for (let index = 0; index < palabra.length; index++) {
          temp.push(" ")
          trueWord.push(palabra[index]);
      }
      this.$data.trueWord=trueWord;
      this.$data.word=temp;
      this.$data.intentosRestantes=5;
      this.$data.foto='ahorcadoNuevo'+this.$data.intentosRestantes+'.png'
      this.$data.letras=[]
      this.$data.ganar=false;
      this.$data.perder=false;
      this.$data.ganarDialog=false;
      this.$data.perderDialog=false;

     }
  },
  components: {
  }
})
